/**
 * Modular What's New entries for the "driver" module: the daily pre-shift check in the Sofőr app. `routes` use the real navigation screen names from AppNavigator.jsx.
 *
 * @type {Object[]}
 */
const driverEntries = [
  {
    id: 'driver-daily-check-2026-10',
    module: 'driver',
    routes: ['DriverDailyCheckScreen', 'DriverHomeScreen'],
    date: '2026-10-27',
    version: '4.16.0',
    global: false,
    type: 'feature',
    title: {
      en: "✅ Daily check before you start driving",
      hu: "✅ Napi ellenőrzőlap indulás előtt",
      de: "✅ Tägliche Kontrolle vor der Abfahrt",
      cn: "✅ 出车前每日检查",
      ro: "✅ Verificarea zilnică înainte de plecare",
      svn: "✅ Dnevni pregled pred odhodom",
    },
    body: {
      en: "Instead of a paper or online form, answer a short checklist right in the Happy app when your work day starts: your plate, phone and printer, the car, the ice load, documents and ITS. Tap Yes or No and the next question appears. If something is wrong or damaged, take photos of the car on the spot and the office sees them immediately.",
      hu: "Papír vagy online űrlap helyett a munkanap kezdetén közvetlenül a Happy appban válaszolsz egy rövid ellenőrzőlapra: rendszám, telefon és nyomtató, az autó, a jégrakomány, dokumentumok és ITS. Koppints az Igen vagy Nem gombra, és jön a következő kérdés. Ha valami hibás vagy megsérült, fotózd le az autót azonnal, az iroda rögtön látja.",
      de: "Statt eines Papier- oder Online-Formulars beantworten Sie zu Arbeitsbeginn direkt in der Happy-App eine kurze Checkliste: Kennzeichen, Telefon und Drucker, Fahrzeug, Eisladung, Dokumente und ITS. Tippen Sie auf Ja oder Nein, und die nächste Frage erscheint. Ist etwas defekt oder beschädigt, fotografieren Sie das Fahrzeug sofort, das Büro sieht es unmittelbar.",
      cn: "无需纸质或在线表格，工作日开始时直接在 Happy 应用中回答一份简短清单：车牌、手机和打印机、车辆、冰块装载、证件和 ITS。点按“是”或“否”，下一个问题随即出现。如有故障或损坏，当场拍摄车辆照片，办公室立即可见。",
      ro: "În loc de un formular pe hârtie sau online, răspunzi la începutul zilei de lucru direct în aplicația Happy la o scurtă listă: numărul de înmatriculare, telefonul și imprimanta, mașina, încărcătura de gheață, documentele și ITS. Atinge Da sau Nu și apare următoarea întrebare. Dacă ceva este defect sau avariat, fotografiază mașina pe loc, iar biroul vede imediat.",
      svn: "Namesto papirnatega ali spletnega obrazca ob začetku delovnega dne v aplikaciji Happy odgovorite na kratek seznam: registrska tablica, telefon in tiskalnik, vozilo, tovor ledu, dokumenti in ITS. Tapnite Da ali Ne in pojavi se naslednje vprašanje. Če je kaj pokvarjeno ali poškodovano, vozilo takoj fotografirajte, pisarna pa to vidi takoj.",
    },
  },
];

export default driverEntries;
